<div class="modal-header">
  <div class="modal-title-container">
    <h5 class="modal-title" id="resetLoginModalLabel">Reset Login</h5>
    <h5 class="modal-title">{{selectedParticipant.participantModifiable.firstName}} {{selectedParticipant.participantModifiable.lastName}}</h5>
  </div>
</div>
@if (currentVerificationType === VerificationType.MultiFactor) {
  <app-multifactor-code-form
    [selectedParticipant]="selectedParticipant"
    [verificationTypes]="verificationTypes"
    [selectedVerificationType]="currentVerificationType"
    (onVerificationChange)="setVerificationType($event)"
  ></app-multifactor-code-form>
}

@if (currentVerificationType === VerificationType.Pin) {
  <app-security-code-form
    [selectedParticipant]="selectedParticipant"
    [verificationTypes]="verificationTypes"
    [selectedVerificationType]="currentVerificationType"
    (onVerificationChange)="setVerificationType($event)"
  ></app-security-code-form>
}
